import React from 'react'
import Loader from 'react-loader-spinner';

const AppSpinner = ({visible = true, type = "ThreeDots", color = "#00BFFF", height = 100, width = 100, style = {}, ...rest }) => {
  return (
    <div style={{ display:'flex', justifyContent: 'center',  alignItems: 'center', flex: '1 1', ...style}}>
      <Loader
        type={type}
        color={color}
        height={height}
        width={width}
        visible={visible}
      />
    </div>
  );
};

export default AppSpinner;